export default "__VITE_ASSET__CwgZDdU___"